import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { Query as RootQuery } from 'graphql/models/generated';

export const SFTP_VALIDATE_QUERY = gql`
  query validateSftp($data: SftpConnectionInput) {
    validateSftp(data: $data) {
      status
      message
    }
  }
`;

@Injectable({
  providedIn: 'root'
})

export class SftpValidateQuery extends Query<RootQuery> {
  document = SFTP_VALIDATE_QUERY;
}
